import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'NewsTag';

const NewsTagApi: any = baseApi(endpoint);

export default NewsTagApi;